import React from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import PhotoLibrarySharpIcon from "@mui/icons-material/PhotoLibrarySharp";
import Galeria3DModels from "../galeria3d/Galeria3DModels";
import { useNavigate } from "react-router-dom";

function ContainerInfo({ product }) {
  const navigate = useNavigate();

  const AbrirGaleria = () => {
    product.imageGallery.length > 0 &&
      navigate("/galeria", {
        replace: true,
        state: {
          imageGallery: product.imageGallery,
          url: window.location.href,
        },
      });
  };
  return (
    <>
      <>
        <div className="container" id="info-products">
          <div className="intro-prod">
            <article className="info-slider margin_posicion col-lg-6 col-sm-12">
              <header className="stiker-card productTitle">
                <h1>{product?.title}</h1>
              </header>
              {product.imageLogo && product?.imageLogo[0]?.url ? (
                <>
                  <img
                    itemProp="logo"
                    src={
                      product.imageLogo
                        ? product.imageLogo[0]?.url
                        : product.imageLogo
                    }
                    alt={
                      product.imageLogo
                        ? product.imageLogo[0]?.alt
                        : product?.title
                    }
                    title={product?.title}
                    className="logo-display info-logo"
                    loading="lazy"
                  />
                  <p className="description_desktop">{product?.top}</p>
                  <p className="description_mobile">{product?.top_mobile}</p>
                </>
              ) : (
                <>
                  <p className="description_desktop mt-3">{product?.top}</p>
                  <p className="description_mobile mt-3">
                    {product?.top_mobile}
                  </p>
                </>
              )}
              {product.type !== undefined &&
                product.type == "productoEspecial" && (
                  <Galeria3DModels nameProd={product.title} />
                )}
              {product?.imageGallery?.length > 0 && product?.galleryEnabled && (
                <div
                  onClick={AbrirGaleria}
                  id="boton-galeria"
                  className="description_mobile ficha-tecnica-button text-center"
                >
                  <p className="p-galeria mb-0">
                    GALERÍA <PhotoLibrarySharpIcon />
                  </p>
                </div>
              )}
            </article>
          </div>
        </div>
      </>
    </>
  );
}

export default ContainerInfo;
